import { Snackbar, Alert } from "@mui/material";

const SnackBarAlert = ({ open, handleClose, message, severity }) => {
    return (
        <Snackbar
            variant="outlined"
            open={open}
            autoHideDuration={10000}
            onClose={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
            <Alert
                variant="filled"
                onClose={handleClose}
                severity={severity}
                sx={{ width: "100%" }}
            >
                {message}
            </Alert>
        </Snackbar>
    );
};

export default SnackBarAlert;
